async function tbAllowKlaviyoPhone(email, phone) {
  if (!phone) return false;
  try {
    const r = await fetch(
      "https://teddy-baldassarre.vercel.app/api/klaviyo-consent-check",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, phone }),
      }
    );
    if (!r.ok) return false;
    const d = await r.json();
    return d.allowPhone === true;
  } catch (err) {
    console.warn("Klaviyo consent check failed, withholding phone", err);
    return false;
  }
}

class TeddysTop402025 extends HTMLElement {
  connectedCallback() {
    this.listId = this.dataset.listId || "";
    this.emailSource = this.dataset.emailSource || "";
    this.smsSource = this.dataset.smsSource || "";
    this.redirectUrl = this.dataset.redirectUrl || "";

    this.form = this.querySelector(".top40-download__form");
    this.errorEl = this.querySelector(".top40-download__error");
    this.submitButton = this.querySelector(".top40-download__submit");

    this.contentWrapper = this.querySelector(".top40-download__content");
    this.successBlock = this.querySelector(".top40-download__success-block");

    if (this.form) {
      this.form.addEventListener("submit", (e) => this.handleSubmit(e));
    }
  }

  showFieldError(name, msg) {
    const field = this.querySelector(`[name="${name}"]`);
    const container = field ? field.closest(".field-container") : null;
    if (!container) return;

    container.classList.add("active");
    const errorText = container.querySelector(".field-error-text");
    if (errorText) errorText.textContent = msg;
  }

  clearFieldError(name) {
    const field = this.querySelector(`[name="${name}"]`);
    const container = field ? field.closest(".field-container") : null;
    if (!container) return;
    container.classList.remove("active");
  }

  setGeneralError(msg) {
    if (!this.errorEl) return;
    if (msg) {
      this.errorEl.style.display = "block";
      this.errorEl.textContent = msg;
    } else {
      this.errorEl.style.display = "none";
      this.errorEl.textContent = "";
    }
  }

  setLoading(isLoading) {
    if (!this.submitButton) return;
    if (isLoading) {
      this.originalText = this.originalText || this.submitButton.innerHTML;
      this.submitButton.innerHTML = "Submitting...";
      this.submitButton.disabled = true;
    } else {
      this.submitButton.innerHTML =
        this.originalText || this.submitButton.innerHTML;
      this.submitButton.disabled = false;
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    const firstName =
      this.querySelector('[name="first-name"]')?.value.trim() || "";
    const lastName =
      this.querySelector('[name="last-name"]')?.value.trim() || "";
    const email = this.querySelector('[name="email"]')?.value.trim() || "";
    const phone = this.querySelector('[name="phone"]')?.value.trim() || "";
    const smsConsent = !!this.querySelector('[name="sms_consent"]')?.checked;

    const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    let hasError = false;
    this.setGeneralError("");

    if (!firstName) {
      this.showFieldError("first-name", "Please complete First Name field");
      hasError = true;
    } else {
      this.clearFieldError("first-name");
    }

    if (!lastName) {
      this.showFieldError("last-name", "Please complete Last Name field");
      hasError = true;
    } else {
      this.clearFieldError("last-name");
    }

    if (!email) {
      this.showFieldError("email", "Please complete Email field");
      hasError = true;
    } else if (!isValidEmail(email)) {
      this.showFieldError("email", "Please provide a valid Email");
      hasError = true;
    } else {
      this.clearFieldError("email");
    }

    // Phone is optional

    if (hasError) return;

    this.setLoading(true);

    try {
      const properties = {
        ...(this.emailSource && { "signup source - email": this.emailSource }),
      };

      if (phone && this.smsSource) {
        properties["signup source - sms"] = this.smsSource;
      }

      const subscriptions = {
        email: {
          marketing: {
            consent: "SUBSCRIBED",
          },
        },
      };

      const allowPhone = await tbAllowKlaviyoPhone(email, phone);

      if (phone && smsConsent && allowPhone) {
        subscriptions.sms = {
          marketing: {
            consent: "SUBSCRIBED",
          },
          transactional: {
            consent: "SUBSCRIBED",
          },
        };
      }

      const profileAttributes = {
        email,
        first_name: firstName,
        last_name: lastName,
        properties,
        subscriptions,
      };

      if (phone && allowPhone) {
        profileAttributes.phone_number = phone;
      }

      const payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: profileAttributes,
              },
            },
          },
          ...(this.listId && {
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: this.listId,
                },
              },
            },
          }),
        },
      };

      const response = await fetch(
        "https://a.klaviyo.com/client/subscriptions/?company_id=JFDzfK",
        {
          method: "POST",
          headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json",
            revision: "2025-01-15",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        let message = "Something went wrong. Please try again.";
        try {
          const errorData = await response.json();
          message = errorData.errors?.[0]?.detail || message;
        } catch (e) {}
        this.setGeneralError(message);
        this.setLoading(false);
        return;
      }

      // Leaf - Custom Event - generate_lead - Start
      try {
        window.LeafCustomEvents?.publishLead?.({
          leadType: "top_40_download",
          leadSource: this.emailSource || "top 40 - landing page",
          email,
          phone,
          firstName,
          lastName,
        });
      } catch (e) {
        // tracking must never break the form flow
      }
      // Leaf - Custom Event - generate_lead - End
      if (this.contentWrapper) {
        this.contentWrapper.classList.add("hidden");
      }
      if (this.successBlock) {
        this.successBlock.classList.remove("hidden");
      }

      this.setGeneralError("");
      this.setLoading(false);

      if (this.redirectUrl) {
        window.location.href = this.redirectUrl;
      }
    } catch (err) {
      console.error("TeddysTop402025 error", err);
      this.setGeneralError("An unexpected error occurred. Please try again.");
      this.setLoading(false);
    }
  }
}

if (!customElements.get("teddys-top-40-2025")) {
  customElements.define("teddys-top-40-2025", TeddysTop402025);
}
